function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import Icon from "./Icon";

var Trash = function Trash(props) {
  return React.createElement(Icon, _extends({
    color: "#ffffff",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, props), React.createElement("path", {
    d: "M15.7672 20.8004H8.23122C7.41602 20.8004 6.73122 20.1876 6.64082 19.3772L5.19922 6.40039H18.7992L17.3576 19.3772C17.2672 20.1876 16.5824 20.8004 15.7672 20.8004Z"
  }), React.createElement("path", {
    d: "M19.2 4.8002H4.8C4.3584 4.8002 4 4.4418 4 4.0002C4 3.5586 4.3584 3.2002 4.8 3.2002H19.2C19.6416 3.2002 20 3.5586 20 4.0002C20 4.4418 19.6416 4.8002 19.2 4.8002Z"
  }), React.createElement("path", {
    d: "M14.4016 4.00039H9.60156V3.20039C9.60156 2.75879 9.95996 2.40039 10.4016 2.40039H13.6016C14.0432 2.40039 14.4016 2.75879 14.4016 3.20039V4.00039Z"
  }));
};

export default Trash;